export default __webpack_public_path__ + "static/media/الرؤية والطبقة الوسطى.9519b141.pdf";